/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { DischargeAdviceApi } from '../api/dischargeadvice.api';
import { switchMap, map } from 'rxjs/operators';
import { DischargeAdviceData, DischargeAdvice } from '../../../interfaces/masters/dischargeadvice';

@Injectable()
export class DischargeAdviceService extends DischargeAdviceData {

  constructor(private api: DischargeAdviceApi) {
    super();
  }


  list(url: string): Observable<DischargeAdvice[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<DischargeAdvice>{
      return this.api.getById(url);
  }

  create(url: string, data:DischargeAdvice): Observable<DischargeAdvice[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:DischargeAdvice): Observable<DischargeAdvice> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
